module.exports = "/_next/static/files/2ec47c5fc1be98b6ff2cb6282c17433a.jpg";